import WindowFunc from "./window";

export const loadCss = () => {
  if (self != WindowFunc.getTop()) {
    if (window.notThrowCss !== true) {
      let topCss = [],
        currentCss = [],
        loadCss = [];
      $("link").each(function() {
        if (
          $(this)
            .attr("href")
            .indexOf("?") > -1
        ) {
          currentCss.push(
            $(this)
              .attr("href")
              .slice(
                0,
                $(this)
                  .attr("href")
                  .indexOf("?")
              )
          );
        } else {
          currentCss.push($(this).attr("href"));
        }
      });
      $(WindowFunc.getTop().document)
        .find("link")
        .each(function() {
          if (
            $(this)
              .attr("href")
              .indexOf("?") > -1
          ) {
            topCss.push(
              $(this)
                .attr("href")
                .slice(
                  0,
                  $(this)
                    .attr("href")
                    .indexOf("?")
                )
            );
          } else {
            topCss.push($(this).attr("href"));
          }
        });
      currentCss.forEach(item => {
        if (topCss.indexOf(item) < 0) {
          loadCss.push(item);
        }
      });
      loadCss.forEach(item => {
        WindowFunc.getTop().document.head.appendChild(
          $(`<link rel="stylesheet" type="text/css" href="${item}">`)[0]
        );
      });
    }
  }
};



// WEBPACK FOOTER //
// ./ecology9/wea-tools/loadCss.js